<app-header (cartOpen)="cartVisible=true" (menuClick)="toggleSidebar()"></app-header>
<div class="sidebar-container h-screen w-full fixed top-0 left-0 overflow-x-hidden z-40"
    [ngClass]="{'sidebar-open': sidebarOpen}">
    <app-sidebar (close)="toggleSidebar()"></app-sidebar>
</div>
<main class="lg:flex-grow " (click)="sidebarOpen=false;$event.stopPropagation()">
    <app-search-modal *ngIf="searchOpen"></app-search-modal>
    <router-outlet></router-outlet>
    <a href="https://wa.me/+918273363610"><i
            class="pi pi-whatsapp text-white bg-primary rounded-full shadow-lg p-1 fixed bottom-16 right-1"
            style="font-size: 3rem; z-index: 999;"></i></a>
</main>
<app-footer></app-footer>

<p-sidebar [(visible)]="cartVisible" position="right" styleClass="w-96">
    <ng-template pTemplate="header">
        <div class="flex gap-4">
            <span class="text-xl font-bold">Shopping Cart</span>
            <i class="pi pi-shopping-cart text-2xl"></i>
        </div>
    </ng-template>
    <div class=" sticky top-0 z-10">
        <app-banner></app-banner>
    </div>
    <app-cart *ngIf="cartVisible" (close)="cartVisible=false" (checkout)="handleCheckout($event)"></app-cart>
    <ng-template pTemplate="footer">
        <div *ngIf="checkoutVisible" class="checkout text-center mt-5 border-primary">
            <hr class=" border-primary">
            <div class="flex gap-2 justify-center items-center p-2">
                <p class="text-black font-bold text-xl">Subtotal: </p>
                <p class="text-black flex items-center gap-2"> <span> <span class="rupee font-bold "></span>
                        {{cartSummary.subtotalAfterDiscount}}</span>
                    <span class="text-red-500 line-through">{{cartSummary.subtotal}}</span>
                </p>
            </div>
            <button (click)="navigateToCheckout()" class=" bg-primary
             text-white font-bold py-2 px-4 w-full
               transition duration-500 ease-in-out 
               hover:bg-white hover:text-primary animate-pulse border-2 hover:border-primary ">Proceed To
                Checkout</button>
        </div>
    </ng-template>
</p-sidebar>

<app-feedback *ngIf="isFeedbackVisible" (modalClose)="closeFeedbackModal()"></app-feedback>